import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { AuthService } from '../core/services/auth.service';

@Component({
  selector: 'app-settings-offcanvas',
  standalone: true,
  imports: [
    CommonModule, 
    TranslateModule
  ],
  templateUrl: './settings-offcanvas.component.html',
  styleUrls: ['./settings-offcanvas.component.css']
})
export class SettingsOffcanvasComponent {

  isLoggingOut = false; 

  constructor(
    private router: Router,
    private authService: AuthService 
  ) { }

  goToPersonalInfo(): void {
    this.router.navigate(['/personal-info']);
    // if (offcanvasElement && bootstrap.Offcanvas.getInstance(offcanvasElement)) {
    //   bootstrap.Offcanvas.getInstance(offcanvasElement).hide();
    // }
  }

  goToChangePasswordPage(): void {
    console.log('准备跳转到修改密码页面...');
    this.router.navigate(['/change-password']);
  }

  logout(): void {
    console.log('Logout action triggered from settings offcanvas...');
    this.isLoggingOut = true; 

    this.authService.logout().subscribe({
      next: (response) => {
        this.isLoggingOut = false; 
        console.log('登出API调用完成, 后端响应:', response);
        this.router.navigate(['/login']);
      },
      error: (err) => {
        this.isLoggingOut = false; 
        console.error('登出API调用失败:', err);
        this.router.navigate(['/login']);
      }
    });
  }
}